export default __webpack_public_path__ + "static/media/alur-box-5.e136f41e.png";